// components/header/MainMenuButton.jsx
// Меню іконка в ChatLayout

import { FiMenu } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import MainMenuDrawer from "../ui/MainMenuDrawer";
import "../../styles/MainMenuButton.css";

export default function MainMenuButton({
  chatId = "",
  open,
  onToggle,
  onClose,
}) {
  const { t } = useTranslation("common");

  return (
    <div className="mainMenuWrap">
      <button
        className="iconBtn"
        aria-label={t("menu")}
        title={t("menu")}
        onClick={(e) => {
          e.stopPropagation();
          onToggle?.();
        }}
      >
        <FiMenu className="iconReact" />
      </button>

      <MainMenuDrawer
        chatId={chatId}
        open={open}
        onClose={onClose}
      />
    </div>
  );
}